import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
// import { composeWithDevTools } from 'redux-devtools-extension';

import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import rootSaga from "./rootsaga";

// IMPORT ALL YOUR REDUCERS HERE
import auth from './auth';
import layout from './layout';
import profile from './profile/profile';
import dashboard from './dashboard';
import job from './job';
import user from './user';
import education from './profile/education';
import setting from './accountsetting';

const appReducer = combineReducers({
    auth,
    layout,
    profile,
    dashboard,
    job,
    user,
    education,
    setting
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const sagaMiddleware = createSagaMiddleware();

const middleWares = [sagaMiddleware, thunk];

export const store = createStore(
    appReducer,
    composeEnhancers(applyMiddleware(...middleWares)),
)

// export default applyMiddleware(...middleWares)(createStore)(appReducer);

sagaMiddleware.run(rootSaga);
